import { BondStep as RequestBondStep } from "../../../../request/create/steps/bond/BondStep";

export const BondStep = () => <RequestBondStep includeCommercialFields />;
